(function () {
  var badgeSelector = '.h-wishlist-icon .wishlist-h-count';
  var maxAttempts = 80;
  var retryDelay = 250;
  var refreshEvents = [
    'sw:addedtowishlist',
    'sw:removedfromwishlist',
    'swym:addedtowishlist',
    'swym:removedfromwishlist',
  ];

  function normalizeCount(count) {
    var value = parseInt(count, 10);
    return Number.isFinite(value) ? value : 0;
  }

  function setBadgeCount(badge, count) {
    var value = normalizeCount(count);
    badge.dataset.count = String(value);

    if (value > 0) {
      badge.textContent = value > 99 ? '99+' : String(value);
      badge.setAttribute('aria-hidden', 'false');
      return;
    }

    badge.textContent = '';
    badge.setAttribute('aria-hidden', 'true');
  }

  function bindBadge(swat, badge) {
    if (!swat || !badge || badge.dataset.swymHeaderCountBound === 'true') {
      return false;
    }

    if (typeof swat.renderWishlistCount === 'function') {
      badge.dataset.swymHeaderCountBound = 'true';
      swat.renderWishlistCount(badge, function (count, element) {
        setBadgeCount(element || badge, count);
      });
      return true;
    }

    if (typeof swat.wishlistCount === 'function') {
      badge.dataset.swymHeaderCountBound = 'true';

      var refresh = function () {
        swat.wishlistCount(function (count) {
          setBadgeCount(badge, count);
        });
      };

      refresh();
      refreshEvents.forEach(function (eventName) {
        document.addEventListener(eventName, refresh);
      });
      return true;
    }

    return false;
  }

  function bindBadges(swat) {
    var activeSwat = swat || window._swat;
    var badges = document.querySelectorAll(badgeSelector);
    var bound = false;

    badges.forEach(function (badge) {
      if (bindBadge(activeSwat, badge)) {
        bound = true;
      }
    });

    return bound;
  }

  function waitForSwym(attempt) {
    if (bindBadges(window._swat)) {
      return;
    }

    if (attempt < maxAttempts) {
      window.setTimeout(function () {
        waitForSwym(attempt + 1);
      }, retryDelay);
    }
  }

  function start(swat) {
    var run = function () {
      bindBadges(swat || window._swat);
      waitForSwym(0);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
      return;
    }

    run();
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    start(swat);
  });

  start();
  window.addEventListener('load', function () {
    start();
  });
})();
